import ObjectID from "bson-objectid";
import type { AnyObject, Flags, Maybe, Message } from "yup";
import { StringSchema } from "yup";

import { string as localeStringErrorMessages } from "@braze/yup-legacy/lib/locale";

export class BrazeStringExtensions<
  TType extends Maybe<string> = string | undefined,
  TContext = AnyObject,
  TDefault = undefined,
  TFlags extends Flags = "",
> extends StringSchema<TType, TContext, TDefault, TFlags> {
  /**
   * Ensure a string is a valid BSON ID
   */
  bsonid(message: Message = (localeStringErrorMessages as any).bsonid): this {
    return this.test({
      name: "bsonid",
      exclusive: true,
      message,
      test: (bsonid) => {
        if (typeof bsonid !== "string") {
          return false;
        }

        return ObjectID.isValid(bsonid);
      },
    });
  }
}

export function string(): BrazeStringExtensions;
export function string<T extends string, TContext extends Maybe<AnyObject> = AnyObject>(): BrazeStringExtensions<
  T | undefined,
  TContext
>;
export function string() {
  return new BrazeStringExtensions();
}
